export function formatTime(
  timeInSeconds: number,
  precision = 0,
  includeHours = false,
) {
  if (!includeHours) {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    if (precision === 0) {
      return `${minutes}:${seconds.toFixed(0).padStart(2, "0")}`;
    }
    return `${minutes}:${seconds.toFixed(precision).padStart(2 + precision + 1, "0")}`;
  } else {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;
    if (precision === 0) {
      if (hours === 0) {
        return `${minutes}:${seconds.toFixed(0).padStart(2, "0")}`;
      } else {
        return `${hours}:${minutes}:${seconds.toFixed(0).padStart(2, "0")}`;
      }
    }
    if (hours === 0) {
      return `${minutes}:${seconds.toFixed(precision).padStart(2 + precision + 1, "0")}`;
    } else {
      return `${hours}:${minutes}:${seconds.toFixed(precision).padStart(2 + precision + 1, "0")}`;
    }
  }
}
